import { MapPin, Calendar } from 'lucide-react';
import { getHijriDate } from '../utils/hijri';
import { LayoutType } from '../types/prayer';

interface HeaderProps {
  currentTime: string;
  location: string;
  layout: LayoutType;
  onLayoutChange: (layout: LayoutType) => void;
  pageTimer?: string | number;
}

export function Header({ currentTime, location, layout, onLayoutChange, pageTimer }: HeaderProps) {
  const hijriDate = getHijriDate();

  const now = new Date();
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const gregorianDate = `${months[now.getMonth()]} ${now.getDate()}, ${now.getFullYear()}`;

  return (
    <div className="text-center space-y-4 mb-6 relative">
      {pageTimer !== undefined && (
        <div className="absolute top-0 right-0">
          <div className="bg-yellow-400 text-gray-900 px-3 py-1.5 rounded-full shadow-lg">
            <div className="text-lg font-bold">
              {pageTimer}
            </div>
          </div>
        </div>
      )}
      <div className="w-full text-[8rem] sm:text-[10rem] md:text-[14rem] lg:text-[18rem] xl:text-[22rem] font-black text-white drop-shadow-2xl tracking-wider leading-none">
        {currentTime}
      </div>

      <div className="flex items-center justify-center gap-3 text-white text-sm flex-wrap">
        <div className="flex items-center gap-1.5 bg-white/10 backdrop-blur-sm px-3 py-1.5 rounded-full whitespace-nowrap">
          <MapPin className="w-4 h-4" />
          <span className="font-semibold">{location}</span>
        </div>

        <div className="flex items-center gap-1.5 bg-white/10 backdrop-blur-sm px-3 py-1.5 rounded-full whitespace-nowrap">
          <Calendar className="w-4 h-4" />
          <span className="font-semibold">{hijriDate}</span>
        </div>

        <div className="flex items-center gap-1.5 bg-white/10 backdrop-blur-sm px-3 py-1.5 rounded-full whitespace-nowrap">
          <Calendar className="w-4 h-4" />
          <span className="font-semibold">{gregorianDate}</span>
        </div>
      </div>

      <div className="flex justify-center mt-3">
        <div className="bg-white/90 rounded-full shadow-lg p-0.5 flex gap-0.5">
          <button
            onClick={() => onLayoutChange('cards')}
            className={`flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold transition-all duration-200 ${
              layout === 'cards'
                ? 'bg-gradient-to-r from-emerald-500 to-teal-600 text-white shadow-md'
                : 'text-gray-600 hover:bg-gray-100'
            }`}
          >
            <span>Cards</span>
          </button>

          <button
            onClick={() => onLayoutChange('table')}
            className={`flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold transition-all duration-200 ${
              layout === 'table'
                ? 'bg-gradient-to-r from-emerald-500 to-teal-600 text-white shadow-md'
                : 'text-gray-600 hover:bg-gray-100'
            }`}
          >
            <span>Table</span>
          </button>
        </div>
      </div>
    </div>
  );
}
